/**
 * Split file of functions.ts containing Angular/Rxjs and related imports.
 * These exports are throwing cypress runtime thus cannot be imported from same file.
 */

import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { getDevicePlatform, isInputError } from './functions';
import { IApiHeadersGetterInput } from 'src/models/app.model';
import packageInfo from 'package.json';

export function investmentAlreadyExistError(error: unknown): boolean {
  return isInputError(error, 422, { acceptedErrorCodes: ['E001'] });
}

const refuseAcceptErrorCodes = [
  'E008', // instruments no longer allowed
  'E022' // greater maxRiskScore than in IQ
];

export function instrumentsNotInAllowedList(error: unknown): boolean {
  return isInputError(error, 400, { acceptedErrorCodes: refuseAcceptErrorCodes });
}

export function notAllowedStrategies(error: unknown): boolean {
  return isInputError(error, 422, { includedErrorMessage: 'Client may no longer create strategies' });
}

export function isDraftExpiredError(error: unknown): boolean {
  return isInputError(error, 422, { acceptedErrorCodes: ['E027'] });
}

export function parseToError(error: unknown): HttpErrorResponse | null {
  let parsedError: null | HttpErrorResponse = null;

  if(typeof error === 'function') {
    parsedError = error() as HttpErrorResponse;
  }
  if(error && typeof error === 'object') {
    parsedError = error as HttpErrorResponse;
  }
  if(!(error instanceof HttpErrorResponse)) {
    console.error('Passed object is not of type HttpErrorResponse!', error);
  }
  return parsedError;
}

export function getAppHeaders(input: IApiHeadersGetterInput): HttpHeaders {
  return new HttpHeaders({
    'accept': input.accept,
    'Authorization': 'Bearer ' + input.accessToken,
    ...(
      input.isNativeApp ?
      {
        'X-Device-Type': getDevicePlatform() ?? '',
        'X-App-Version': packageInfo.version,
      } :
      {}
    )
  });
}
